export default function ReadonlyDataTable({
  rows,
  title,
  description,
}: {
  rows: Record<string, unknown>[];
  title: string;
  description?: string;
}) {
  if (rows.length === 0) return null;
  const columns = Object.keys(rows[0]);
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-900 mb-2">{title}</h3>
      {description && <p className="text-xs text-gray-500 mb-2">{description}</p>}
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs border-collapse">
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col}
                  className="border border-gray-300 bg-gray-50 px-2 py-1 text-left font-medium text-gray-600 whitespace-nowrap"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className="odd:bg-white even:bg-gray-50">
                {columns.map((col) => (
                  <td key={col} className="border border-gray-200 px-2 py-0.5 whitespace-nowrap">
                    {String(row[col] ?? '')}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
